import { all, takeLatest } from 'redux-saga/effects';

import { GoogleAnalyticsActions } from '../../constants';

function* sendGAEvent(action) {
  yield window.gtag('event', action.eventName, {
    event_category: action.category,
    event_label: action.label,
  });
}

function* setUserID(action) {
  yield all([
    window.gtag('set', { user_id: action.userId }),
    window.gtag('set', 'user_properties', {
      user_identifier: action.userId,
    }),
  ]);
}

// This saga handles changes to the code panel
export default function* googleAnalyticsSaga() {
  yield takeLatest(GoogleAnalyticsActions.SEND_GA_EVENT, sendGAEvent);
  yield takeLatest(GoogleAnalyticsActions.SET_USER_ID, setUserID);
}
